<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/tuning/tuning.jpg" alt="软件算法">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">Tuning</div>
                <div class="detail-banner-desc">
                    Professional tuning team;<br />
                    Customized tuning for each vehicle model to maximize the in-cabin listening experience;<br />
                    Strong data analysis capability with clear subjective and objective targets;<br />
                    It features accurate sound localization, wide soundstage, precise frequency response, rich details,
                    and balanced listening experience at all positions.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Tuning Technology</div>
                    <div class="detail-desc">
                        <div>
                            Amor Aural® In‑Cabin Sound Field Reconstruction Technology: Based on in‑vehicle acoustic
                            transfer function computation and analysis, it precisely coordinates multiple speakers and
                            reduces system distortion, achieving alignment between subjective and objective acoustic
                            performance and ensuring balanced sound for every seating position.
                        </div>
                        <div>
                            Proprietary Engine Active Noise Cancellation(EOC) and Road Noise Cancellation(RNC)
                            Calibration Solution: Based on in‑vehicle noise transfer path analysis and real‑time
                            operating condition response, it precisely adjusts the gain and phase of the active control
                            strategy, achieving effective attenuation of engine order noise and road‑induced noise, and
                            ensuring consistent quietness across the full speed range and all road conditions while
                            enhancing subjective comfort.
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/tuning/tyjs.jpg" alt="调音技术">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Team Strengths
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Our tuning team brings over ten years of research and practical
                                        experience in acoustics, with previous experience at world-renowned audio
                                        brands.</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Tuning Room</div>
                    <div class="detail-desc">
                        <div>
                            Professional Tuning Laboratory & Standard Listening Room: Support listening comparison,
                            algorithm verification, tuning, and other needs, covering everything from basic adjustments
                            to complex acoustic environments (audio & noise cancellation).
                        </div>
                    </div>
                </div>

                <div class="spec-row">

                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Team Strengths
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Our tuning team brings over ten years of research and practical
                                        experience in acoustics, with previous experience at world-renowned audio
                                        brands.</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/tuning/tys.jpg" alt="调音室">
                    </div>
                </div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'Tuning - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/tuning.html'
};

import { createApp } from 'vue';
import App from './tuning.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./tuning.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
